import { Component, OnInit } from '@angular/core';
import { Message, MessageTypes } from '../message';
import { Router } from '@angular/router';
import { MenuService } from '../menu/menu.service';

@Component({
    selector: 'app-calendar',
    templateUrl: './calendar.component.html',
    styleUrls: ['./calendar.component.css']
})
export class CalendarComponent implements OnInit {
    public message: Message;
    constructor(protected router: Router, protected menuService: MenuService) {
        this.message = {text: '', type: MessageTypes.None};
    }

    ngOnInit() {
    }

    public showMessage(text: string, type: MessageTypes){
        this.message = {text: text, type: type};
    }

    public calendarAdded() {
        // console.log('this should navigate to calendar list');
        this.router.navigate(['/calendar/list']);
    }
}



// WEBPACK FOOTER //
// ./src/app/calendar/calendar.component.ts